import React from "react";
import { Button } from "reactstrap";

const ScrollToBottomButton = ({ onClick, newMessageCount = 0 }) => {
  if (!onClick) return null;

  return (
    <div
      style={{
        position: "absolute",
        bottom: "100%",
        left: "50%",
        transform: "translateX(-50%)",
        marginBottom: "10px",
        zIndex: 1000,
        pointerEvents: "auto"
      }}
    >
      <Button
        color="primary"
        onClick={onClick}
        style={{
          borderRadius: "20px",
          padding: "8px 16px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
          display: "flex",
          alignItems: "center",
          gap: "8px",
          fontSize: "14px",
          fontWeight: 500
        }}
      >
        <i className="ri-arrow-down-line"></i>
        {newMessageCount > 0 && (
          <span
            style={{
              backgroundColor: "rgba(255,255,255,0.3)",
              borderRadius: "10px",
              padding: "2px 8px",
              fontSize: "12px",
              fontWeight: 600
            }}
          >
            {newMessageCount} new
          </span>
        )}
        <span>Scroll to bottom</span>
      </Button>
    </div>
  );
};

export default ScrollToBottomButton;

